import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";

import { Particles } from "@circle-react/apps/EoyRecapApp/Sections/components/Particles";
import { NavigationTabs } from "@circle-react/apps/EoyRecapApp/Sections/components/NavigationTabs";

import { Hero } from "@circle-react/apps/EoyRecapApp/Sections/components/Hero";
import { Engagement } from "@circle-react/apps/EoyRecapApp/Sections/Engagement";
import { Community } from "@circle-react/apps/EoyRecapApp/Sections/Community";
import { EOY_RECAP_VIEW_TYPES } from "@circle-react/apps/EoyRecapApp/constants";
import { Loader } from "@/react/components/shared/uikit/Loader";

import { useAdminMetrics } from "./hooks/useAdminMetrics";
import { Reach } from "@/react/apps/EoyRecapApp/Sections/Reach";
import { Efficiency } from "@/react/apps/EoyRecapApp/Sections/Efficiency";

export const EoYRecap2025Page = () => {
  const { width, height } = useWindowSize();
  const { metrics, isMetricsLoading } = useAdminMetrics();

  if (isMetricsLoading)
    return (
      <div className="size-full flex items-center justify-center">
        <Loader />
      </div>
    );

  return (
    <main className="bg-[#0F0F35]">
      <ReactConfetti
        width={width}
        height={height}
        style={{
          zIndex: 999999,
        }}
        recycle={false}
        tweenDuration={6000}
        numberOfPieces={100}
        gravity={0.15}
        wind={0.05}
        colors={[
          "#a855f7",
          "#9333ea",
          "#7e22ce",
          "#6b21a8",
          "#ffffff",
          "#fbbf24",
          "#f59e0b",
        ]}
        initialVelocityY={-20}
        initialVelocityX={15}
      />
      <Particles />
      <NavigationTabs scrollContext={EOY_RECAP_VIEW_TYPES.ADMIN} />
      <Hero />
      <Community data={metrics?.community_growth} />
      <Engagement data={metrics?.content_experience} />
      <Reach data={metrics?.email_highlights} />
      <Efficiency data={metrics?.automation_efficiency} />
    </main>
  );
};
